import React from 'react';
import uniqueId from 'lodash/uniqueId';

// Slices
import CTASlice from '../components/slices/cta';
import TabsSlice from '../components/slices/tabs';
import TableSlice from '../components/slices/table';
import ColumnsSlice from '../components/slices/columns';
import IconBoxesSlice from '../components/slices/icon-boxes';
import StatBoxesSlice from '../components/slices/stat-boxes';
import TextImageCTASlice from '../components/slices/text-image-cta';
import TitleContentBoxSlice from '../components/slices/title-content-box';
import TitleContentColumnsSlice from '../components/slices/title-content-columns';
import TitleContentBackgroundSlice from '../components/slices/title-content-background';
import RheiaCaseStudy from '../components/slices/rheia-case-study';
import CaseStudySelector from '../components/slices/case-study-selector';
import QuoteColumnsSlice from '../components/slices/quote-columns'
import LogoGrid from '../components/slices/logo-grid'
import TitleContentCtaVideoBackgroundSlice from '../components/slices/title-content-cta-video-background'
import { useUniqueIds } from './general';

/* eslint no-unused-vars: 0 */

const slices = {
  cta: CTASlice,
  tabs: TabsSlice,
  table: TableSlice,
  columns: ColumnsSlice,
  icon_boxes: IconBoxesSlice,
  stat_boxes: StatBoxesSlice,
  text_image_cta: TextImageCTASlice,
  title_content_box: TitleContentBoxSlice,
  title_content_columns: TitleContentColumnsSlice,
  title_content_background: TitleContentBackgroundSlice,
  rheia_case_study: RheiaCaseStudy,
  case_stud_selector: CaseStudySelector,
  quote_columns: QuoteColumnsSlice,
  logo_grid: LogoGrid,
  title_content_cta_video_background: TitleContentCtaVideoBackgroundSlice,
}

const buildSlice = slice => {
  return new Promise( ( resolve, reject ) => {
    if( slices.hasOwnProperty( slice.slice_type ) ) {
      const Component = slices[ slice.slice_type ]

      resolve( <Component key={ slice.uniqueId } slice={ slice } /> )
    } else {
      resolve( '' ) // What happens if I use reject instead?
    }
  })
}

const sliceBuilder = slices => {
  const slicesWithIds = slices.map( slice => {
    slice.uniqueId = uniqueId()

    return slice
  })

  const promises = slicesWithIds.map( slice => buildSlice( slice ).then( result => result ) )

  return Promise.all( promises ).then( results => results )
}

export { sliceBuilder }
